import {
  Card,
  CardBody,
  CardProps,
  Link as ChakraLink,
  Flex,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { FC } from 'react';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { formatPhoneNumber } from '~/common/utils/formatter';
import { agentContactInfoFromListing } from '../../components/Storefront/ListingAgent/ListingAgentCard';
import { useStorefrontContext } from './StorefrontContext';

export const UnderConstructionCard: FC<CardProps> = (props) => {
  const { loading, listing } = useStorefrontContext();

  if (loading) {
    return <CenterSpinner />;
  }

  const { fullName, email, phoneNumber } = agentContactInfoFromListing(listing);

  return (
    <Card w={{ base: '340px', md: '500px' }} {...props}>
      <CardBody>
        <Flex direction="column" gap={4}>
          <Heading as="h2" fontSize="lg">
            Please contact {fullName ? fullName : 'the Listing Agent'} for
            property details and offer submission.
          </Heading>
          <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
            {!!email && (
              <ChakraLink
                alignItems="center"
                display="flex"
                gap={1}
                href={`mailto:${email ?? ''}`}
                onClick={(e) => e.stopPropagation()}
              >
                <Icon as={MailIcon} boxSize="14px" />
                <Text>{email}</Text>
              </ChakraLink>
            )}
            {!!phoneNumber && (
              <ChakraLink
                alignItems="center"
                display="flex"
                gap={1}
                href={`tel:${phoneNumber ?? ''}`}
                onClick={(e) => e.stopPropagation()}
              >
                <Icon as={PhoneIcon} boxSize="14px" />
                <Text>{formatPhoneNumber(phoneNumber)}</Text>
              </ChakraLink>
            )}
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};
